import {apiFetch} from '../../Config/api'

export function requestPractice(data) {
    return apiFetch('stage/practice', data)
}
